
const equalizeElements = function(elementsToBeEqualized, stopBreakPoint) {
	let highest = 0;

	for (let i = 0; i < elementsToBeEqualized.length; i++) {
		const element = elementsToBeEqualized[i];
		element.style.height = '';

		if(stopBreakPoint.matches) {
			continue;
		}

		if(element.offsetHeight > highest) {
			highest = element.offsetHeight;
		}
	}

	if(highest > 0) {
		for (let y = 0; y < elementsToBeEqualized.length; y++) {
			const element = elementsToBeEqualized[y];
			element.style.height = highest + 'px';
		}
	}
}

const equalHeightElements = function(selector, stopEqualizeBreakpoint) {
	const elementsToBeEqualized = document.querySelectorAll(selector);
	const stopBreakPoint = window.matchMedia('(max-width: '+stopEqualizeBreakpoint+')');

	equalizeElements(elementsToBeEqualized, stopBreakPoint);

	window.addEventListener('resize', () => {
		equalizeElements(elementsToBeEqualized, stopBreakPoint);
	});
}

export default equalHeightElements;